module.exports = __webpack_public_path__ + "img/side-icon-13.32cccb32.svg";